export default __webpack_public_path__ + "static/media/150.e30b05db.gif";